
export default function Profile() {
  return <div>Profile Settings</div>;
}
